<template>
  <div>
    <a-row>
      <a-col :span="24">
        <div class="t1">
          <template>
            <table>
              <tr>
                <th>包组名称：</th>
                <td colspan="3">{{ packs.packName }}（包组编号：{{ packs.packCode }}）
                  <a-button type="link" icon="search" size="small" @click="onSubject">查看标的物</a-button>
                </td>
              </tr>
              <tr>
                <th>竞价方式：</th>
                <td>
                  {{ packs.jingjiaWay === '1' ? '自由竞价' : '单轮竞价' }}
                  -
                  {{ packs.jingjiaType === '1' ? '竞高价' : '竞低价' }}
                  <span class="ml-5">
                                           {{ packs.jingjiaType === '1' ? '最低限价：' : '最高限价：' }}
                                    </span>
                  <span v-if="packs.priceStart">{{ packs.priceStart }} {{getPriceText}}{{getPriceTypeText}}</span>
                  <span class="ml-5">竞价开始时间：</span>
                  <span class="mr-5" style="color: red;">
                                        {{ startDate2 }}
                                    </span>
                </td>
                <th>竞价时长:</th>
                <td>
                  &nbsp;&nbsp;
                  {{ packs.duration }} 分钟
                  &nbsp;&nbsp;&nbsp;
                  <span v-if="packs.countDown">
                                     倒计时长
                                    <span class="color-main"> {{ packs.countDown }}</span>
                                     分钟
                                    </span>
                </td>
              </tr>
            </table>
          </template>

          <a-button class="btn" type="primary" icon="question-circle" @click="() => (modal2Visible = true)">
            单轮竞价说明
          </a-button>
          <a-modal
              v-model="modal2Visible"
              title="单轮竞价说明"
              :footer="null"
              centered
              @ok="() => (modal2Visible = false)"
          >
            <p>报名供应商在竞价时限内，只能进行 <span class="color-red">一次报价</span>操作，系统以该报价作为供应商的最终报价。
            </p>
            <p>在竞价时限内，各个供应商的报价<span class="color-red">互不可见</span>，招标代理机构的经办人对所有供应商的报价<span
                class="color-red">也不可见</span>。</p>
            <p>竞价时限到期后竞价结束，系统<span class="color-red">自动公布</span>所有供应商的报价，并按照“满足竞价项目要求且有效报价最高（或最低）”的原则自动确定拟成
            </p>
            <p>交供应商。<span
                class="color-red">如存在多条相同的最高（或最低）报价，则以先报价的供应商为拟成交供应商。</span></p>

            <div>
              <b class="bold size3 color-black">单轮竞价方式</b>
              <p>
                单轮竞价包括 <span class="color-red">竞低价</span> 和 <span class="color-red">竟高价</span> 两种方式，竞低价为最低价成交；竞高价为最高价成交。
              </p>
            </div>
            <div>
              <b class="bold size3 color-black">报价限制</b>
              <p class="mb-0">供应商报价必须不高于最高限价（或不低于最低限价）。</p>
            </div>
            <div>
              <b class="bold size3 color-black">项目失败条件</b>
              <p class="mb-0">条件一：<span class="color-red">报名供应商数量</span>少于竞价文件所规定的家数。</p>
              <p class="mb-0">条件二：<span class="color-red">报价供应商数量</span>少于竞价文件所规定的家数。</p>
              <p>一般情况下，系统自动根据以上两类失败条件来自动判定项目是否竞价失败。
                如竞价过程中发生异常情况（如发现供应商有串标行为），可以由采购人来决定项目是否失败。</p>
            </div>
          </a-modal>
        </div>
        <div>
          <BidSubject ref="sbt" :visible="bidSubjectVisible" @cancel="cancel"></BidSubject>
        </div>
      </a-col>
      <a-col :span="24" style="padding: 0 100px" v-if="competeResultState.code === 2 || competeResultState.code === 3">
        <div class="text-center ml-5 mr-5">
          <div style="text-align: center;">
            <h2 style="color: red;border: 1px solid #e6e6e6;padding: 30px 0;margin: 40px auto;width: 600px">
              <B>{{ competeResultState.msg }}</B></h2>
          </div>
        </div>
      </a-col>
      <a-col :span="24" style="padding: 0 100px" v-if="competeResultState.code !== 2">
        <div class="d-flex mt-5 mb-2" v-if="status === '1'">
          <div class="w-100 arrow">
            <p class="text-left mb-0">常规竞价阶段 ({{ packs.duration }} 分钟)</p>
            <a-progress strokeColor="#f5f5f5" :strokeWidth="strokeWidth" :percent="percent1" :show-info="false"/>
          </div>
          <!--                    <div class="flex-grow-shrink arrow">-->
          <!--                        <p class="text-left mb-0">倒计时阶段 <span v-if="packs.countDown">({{packs.countDown}} 分钟)</span> </p>-->
          <!--                        <a-progress strokeColor="#f5f5f5" style="width: 200px" :strokeWidth="strokeWidth"  :percent="percent2" :show-info="false" />-->
          <!--                    </div>-->
        </div>
        <div class="text-center" style="margin: 30px 200px;border: 1px solid #e6e6e6;padding-bottom: 10px">
          <h2 v-if="status === '1'">
            {{ prefix }}
            <span>&nbsp;</span>
            <span style="color: red;font-size: 30px;" v-if="day">{{ day }}</span>
            <span v-if="day">天</span>
            <span style="color: red;font-size: 30px;" v-if="hour">{{ hour }} </span>
            <span v-if="hour">时</span>
            <span style="color: red;font-size: 30px;">{{ minutes }}</span>
            分
            <span style="color: red;font-size: 30px;">{{ seconds }}</span>
            秒
          </h2>
          <div style="text-align: center;">
            <h2 style="color: red;font-size: 24px;margin-top: 20px"
                v-if="status === '2' && competeResultState.code !== 3 "><B>竞价已结束</B></h2>
          </div>
          <span v-if="serveDate && status === '1'">当前服务器时间 {{ serveDate }}</span>
        </div>
        <div class="t2">
          <div class="size3 color-black"></div>
          <div v-if="status === '1'">
            <span>报价记录实时自动刷新。如遇问题请手动刷新</span>
            <a-button type="primary" @click="onFresh" :size="small" ghost>手动刷新</a-button>
          </div>
        </div>
        <div style="text-align: center;margin-top: 5px">
          <a-button type="primary" :loading="expertLoading" icon="export" @click="expertProcess">
            导出竞价过程
          </a-button>
        </div>
        <table class="t3">
          <colgroup>
            <col width="30%"/>
            <col width="200"/>
            <col width="200"/>
            <col/>
            <col width="200"/>
          </colgroup>
          <thead>
          <tr>
            <td>竞价人</td>
            <td>竞价人编号</td>
            <td>报价（{{getPriceText}}）</td>
            <td>报价时间</td>
            <td>报价ip</td>
          </tr>
          </thead>
        </table>
        <div class="scrollbar-zdy">
          <table class="t3">
            <colgroup>
              <col width="30%"/>
              <col width="200"/>
              <col width="200"/>
              <col/>
              <col width="200"/>
            </colgroup>
            <tbody>
            <tr v-for="it in data">
              <td>
                {{ it.supplierName }}
              </td>
              <td>{{ it.competeNo }}</td>
              <td><span v-if="it.price">{{packs.offerType=='1'?it.price.toLocaleString("en-US"):(it.price*100).toFixed(2).toLocaleString("en-US")}}</span><span v-else>****</span></td>
              <td>{{ it.priceDate }}</td>
              <td>{{ it.clientIp }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div style="height: 120px"></div>

      </a-col>
    </a-row>
  </div>

</template>

<script>
import qs from 'qs'
import CountDown from '@/components/CountDown/CountDown'
import BidSubject from './BidSubject'
import moment from 'moment'
import { ExportExcel } from '@/views/bid/BidUtil'

export default {
  props: {
    packId: {
      type: String,
      required: true
    }
  },
  name: 'SingleCompete',
  components: {
    CountDown,
    BidSubject,
    moment
  },
  computed: {
    getPriceText(){
      return (this.packs.offerType=='1'?'元':'%')
    },
    getPriceTypeText(){
      const offerType = this.packs.offerType
      return (offerType=='1'?'':offerType=='2'?'（折扣率）':'（下浮率）')
    }
  },
  created () {
    this.initPacks()//加载包件基本信息
  },
  beforeDestroy () {
    clearInterval(this.serveDateTimer)
    clearInterval(this.countDownTimer)
    clearInterval(this.reconInv)
  },
  data () {
    return {
      small: 'small',
      data: [],
      packs: [],
      myPrice: '',
      competeNo: '',
      startDate: '',
      startDate2: '',
      serveDate: '',//服务器时间
      serveDateTimer: '',
      currentSupplierId: '',
      lastedData: '',
      competeType: '',
      stopDate: 0,//最终结束时间
      status: '',//  1竞价中，2已结束
      reconInv: '',
      prefix: '离常规竞价阶段结束还有',
      strokeWidth: 20,
      min: 0,
      max: 1000000000,
      bidSubjectVisible: false,
      competeResultState: '',
      day: '',
      hour: '',
      minutes: '',
      seconds: '',
      countDownTimer: '',
      modal2Visible: false,
      processTimer: '',
      commonResultDate: '',//常规竞价结束时间
      percent1: 0,
      percent2: 0,
      openDate: 0,//竞价开始时间
      isFreshed: false,
      dateDisparity: 0,//时间差距
      loading: false,
      expertLoading: false
    }
  },
  methods: {
    setModal1Visible (modal1Visible) {
      this.modal1Visible = modal1Visible
    },
    initPacks () {
      let that = this
      this.$http.get('/api/v1/agency/singleCompete/initPackInfo/' + this.packId).then(function (res) {
        if (res.serveDate) {
          that.serveDate = res.serveDate.replace(new RegExp(/-/gm), '/') //读取服务器时间
        }
        if (res.result.extras.openTime) {
          that.startDate = res.result.extras.openTime.replace(new RegExp(/-/gm), '/')
          that.startDate2 = res.result.extras.openTime.replace(new RegExp(/-/gm), '/')
          that.startDate2 = moment(new Date(that.startDate2)).format('YYYY/MM/DD HH:mm')
        }
        if (res.commonResultDate) {
          that.commonResultDate = res.commonResultDate.replace(new RegExp(/-/gm), '/')
        }
        if (res.stopDate) {
          that.stopDate = res.stopDate.replace(new RegExp(/-/gm), '/')
        }
        if (res.openDate) {
          that.openDate = res.openDate.replace(new RegExp(/-/gm), '/')
        }
        that.dateDisparity = new Date(that.serveDate).getTime() - new Date().getTime()
        console.log(that.dateDisparity)
        that.packs = res.result
        // that.currentSupplierId = res.supplierId //供应商ID
        // that.competeNo = res.result.extras.competeNo //竞价编号
        that.competeType = that.packs.jingjiaType
        that.competeResultState = res.competeResultState //竞价结果状态
        if (that.packs.countDown === '0') {
          that.packs.countDown = ''
        }
        if (that.packs.jingjiaType === '2') {
          that.max = that.packs.priceStart        //报价所需要的最大值
        } else if (that.packs.jingjiaType === '1') {
          that.min = that.packs.priceStart        //最小值
        }
        if (that.competeResultState.code !== 2) {
          //避免延迟显示
          that.getCountDownDate()
          that.onProcess()
          that.serveDateTimer = setInterval(that.getServerDate, 1000)// 动态改变服务器时间
          that.countDownTimer = setInterval(that.getCountDownDate, 1000) // 倒计时
          that.processTimer = setInterval(that.onProcess, 1000) //进度条倒计时
          that.getCompeteInfo()//加载竞价数据
        }
      })
    },
    onFresh () {
      this.getCompeteInfo()
    },
    getCompeteInfo () {// 获取竞价数据
      let that = this
      this.$http.get('/api/v1/agency/singleCompete/getCompetePriceInfo/' + this.packId).then(function (res) {
        if (res.code = 200) {
          that.data = res.result
        } else {
          that.$message.info('数据异常')
        }
      })
    },
    getServerDate () {//动态改变服务器时间
      // this.serveDate = moment(new Date(new Date(this.serveDate).getTime() + 1000)).format('YYYY/MM/DD HH:mm:ss')
      this.serveDate = moment(new Date().getTime() + this.dateDisparity).format('YYYY/MM/DD HH:mm:ss')
    },
    getCountDownDate () {
      var date = new Date(this.commonResultDate).getTime() - new Date(this.serveDate).getTime()
      if (date > 0) {
        this.getCompeteInfo()
        // **************************************常规倒计时********************************************************
        this.status = '1'
        this.prefix = '离常规竞价阶段结束还有'
        var days = Math.floor(date / 1000 / 60 / 60 / 24) // 从这里开始
        var daysmod = date - days * 24 * 60 * 60 * 1000
        var hours = Math.floor(daysmod / 1000 / 60 / 60)
        var hoursmod = date - (days * 24 * 60 * 60 * 1000) - (hours * 1000 * 60 * 60)
        var minutes = Math.floor(hoursmod / 1000 / 60)
        var minutesmod = date - (days * 24 * 60 * 60 * 1000) - (hours * 1000 * 60 * 60) - (minutes * 1000 * 60)
        var seconds = Math.floor(minutesmod / 1000) // 到这里结束，是将总毫秒转化成对应天数+小时数+分钟数+秒数的转换方法

        if (hours === 0 && hours === 0) {
          this.day = ''
          this.hour = ''
        } else {
          this.day = days
          this.hour = hours
        }
        this.minutes = minutes
        this.seconds = seconds
      } else {
        this.status = '2'
        this.getCompeteInfo()
        // 清除定时器
        clearInterval(this.getServerDate)
        clearInterval(this.countDownTimer)
      }
    },
    onProcess () {//初始化进度条
      var common2 = new Date(this.commonResultDate).getTime() - new Date(this.serveDate).getTime()//常规阶段后一段
      if (common2 > 0) {
        //常规阶段
        var commonCount = new Date(this.commonResultDate).getTime() - new Date(this.openDate).getTime()//常规总长度
        this.percent1 = (1 - common2 / commonCount) * 100
      } else {
        this.percent1 = 100
      }
    },
    onSubject () {
      this.bidSubjectVisible = true
      this.$refs.sbt.initData(this.packId)
    },
    cancel () {
      this.bidSubjectVisible = false
    },
    sysError (content) {
      let secondsToGo = 3
      const modal = this.$error({
        title: '温馨提示',
        content: content,
      })
      const interval = setInterval(() => {
        secondsToGo -= 1
        modal.update({
          content: content,
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        modal.destroy()
      }, secondsToGo * 1000)
    },
    sysWarning (content) {
      let secondsToGo = 2
      const modal = this.$warning({
        title: '温馨提示',
        content: content,
        footer: ''
      })
      const interval = setInterval(() => {
        secondsToGo -= 1
        modal.update({
          content: content,
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        modal.destroy()
      }, secondsToGo * 1000)
    },
    expertProcess () {
      this.expertLoading = true
      const url = '/api/v1/compete/export_process_by_pack.json'
      ExportExcel(this, url, { packId: this.packId }, this.packs.packName + '竞价过程')
      this.expertLoading = false
    },
  }
}
</script>

<style scoped>
.t1 {
  background: #f9f9f9;
  border: 1px solid #e6e6e6;
  padding: 6px 12px;
  position: relative;
}

.t1 table {
  table-layout: fixed;
}

.t1 th {
  text-align: justify;
  text-align-last: justify;
  color: #8c8c8c;
  font-weight: 500;
}

.t1 td {
  color: #262626;
  font-weight: bold;
  padding: 6px 50px 6px 0;
}

.t1 .btn {
  position: absolute;
  right: 20px;
  margin: auto;
  top: 0;
  bottom: 0;
}

.t2 {
  display: flex;
  justify-content: space-between;
  border-bottom: 4px solid #f7f7f7;
  padding: 8px 0;
}

.t3 {
  width: 100%;
}

.t3 td {
  font-weight: 500;
  border-bottom: 1px solid #e6e6e6;
  padding: 12px 0;
  text-align: center;
}

.t3 thead td {
  color: #8c8c8c;
}

.t3 tbody tr:nth-child(1) td {
  background: #FFF5EF;
}

.t3 td:nth-child(1) {
  text-align: left;
}

.t3 td:nth-last-child(1) {
  text-align: center;
}

.t4 {
  width: 200px;
  height: 60px;
  text-align: center;
}

/deep/ .t4 .ant-input-number-input {
  font-size: 30px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #ff0000;
}

.scrollbar-zdy {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 460px;
  margin-right: -4px;
}

/*-------滚动条整体样式----*/
.scrollbar-zdy::-webkit-scrollbar {
  width: 4px;
}

/*滚动条里面小方块样式*/
.scrollbar-zdy::-webkit-scrollbar-thumb {
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.2);
}

/*滚动条里面轨道样式*/
.scrollbar-zdy::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

/deep/ .d-flex .ant-progress-inner {
  border-radius: 0;
  overflow: inherit;
}

/deep/ .d-flex .ant-progress-bg {
  border-radius: 0 !important;
}

/deep/ .d-flex .w-100.arrow .ant-progress-bg::before {
  content: "";
  border-top: 10px solid rgba(0, 0, 0, 0);
  border-right: 10px solid rgba(0, 0, 0, 0);
  border-bottom: 10px solid #509eff;
  border-left: 10px solid rgba(0, 0, 0, 0);
  position: absolute;
  right: -10px;
  top: 10px;
}

/deep/ .d-flex .flex-grow-shrink.arrow .ant-progress-bg::before {
  content: "";
  border-top: 10px solid rgba(0, 0, 0, 0);
  border-right: 10px solid rgba(0, 0, 0, 0);
  border-bottom: 10px solid #ff5454;
  border-left: 10px solid rgba(0, 0, 0, 0);
  position: absolute;
  right: -10px;
  top: 10px;
}

/deep/ .d-flex .w-100 .ant-progress-inner {
  background: #509eff;
}

/deep/ .d-flex .flex-grow-shrink .ant-progress-inner {
  background: #ff5454;
}
</style>
